import type {Values} from "@wix/devzai-utils-common";

export const DoppeAutoProductType = {
    Latest: 'Latest',
    BestSellers: 'BestSellers',
    Categories: 'Categories',
} as const;

export type DoppeAutoProductType = Values<typeof DoppeAutoProductType>;